var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 480,
    viewBox: "0 0 384 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.375,
    cy: 173.375,
    r: 66.875,
    fill: "#1A1A1A",
    stroke: "white",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5362 372.5C55.228 314.167 115.969 266.391 191.92 266.391C267.871 266.391 328.611 314.167 330.303 372.5H53.5362Z",
    fill: "#1A1A1A",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/empty-image.7f4f0e9e0b07d0ef0b4eff7f29a91988.svg";
export { ForwardRef as ReactComponent };